import classNames from "classnames/bind";
import { Button } from "common/buttons";
import { useToggle } from "common/hooks/useToggle";
import * as React from "react";
import { KurssloeyfeElementNavList } from "./KurssloeyfeElementNavList";
import styles from "./KurssloeyfeMobileMenu.module.css";

const classNameBuilder = classNames.bind(styles);

interface Props {
  title: string;
  currentElementTitle: string;
}

export const KurssloeyfeMobileMenu: React.FC<
  React.PropsWithChildren<Props>
> = ({ title, currentElementTitle }) => {
  const [collapsed, setCollapsed] = useToggle(true);

  return (
    <header
      className={classNameBuilder({
        topbar: true,
        open: !collapsed,
      })}
    >
      <div className={styles.topbarHeader}>
        <Button onClick={setCollapsed}>
          {collapsed ? "Se innhold" : "Lukk"}
        </Button>
        <div className={styles.title}>
          <h4>{title}</h4>
          <p>{currentElementTitle}</p>
        </div>
      </div>
      <div
        className={classNameBuilder({
          menu: true,
          collapsed: collapsed,
        })}
      >
        <KurssloeyfeElementNavList onElementClick={setCollapsed} />
      </div>
    </header>
  );
};
